import * as actionTypes from './action-types'

export const fetchSearches = () => ({
  type: actionTypes.FETCH_SEARCHES,
})

export const fakeRemoveSearches = ids => ({
  type: actionTypes.FAKE_REMOVE,
  payload: { ids },
})

export const removeSearches = ids => ({
  type: actionTypes.REMOVE,
  payload: { ids },
})

export const fetchSearchDetails = ({
  id,
  page,
  keyword,
  filters,
  data,
} = {}) => ({
  type: actionTypes.FETCH_SEARCH_DETAILS,
  payload: { id, page, keyword, filters, data },
})

export const clearSearchDetails = () => ({
  type: actionTypes.CLEAR_SEARCH_DETAILS_FILTERS,
})

export const fetchSearchOptions = ({ id, name, keyword, filters, data }) => ({
  type: actionTypes.GET_SEARCH_OPTIONS,
  payload: { id, name, keyword, filters, data },
})

export const clearSearchOptions = () => ({
  type: actionTypes.CLEAR_SEARCH_OPTIONS,
})

export const setSearchToSave = data => ({
  type: actionTypes.SET_SEARCH_TO_SAVE,
  payload: data,
})

export const clearSearchToSave = () => ({
  type: actionTypes.CLEAR_SEARCH_TO_SAVE,
})

export const saveSearch = data => ({
  type: actionTypes.SAVE,
  payload: data,
})

export const addVendor = (identification_code, mustShowSnackbar) => ({
  type: actionTypes.ADD_VENDOR,
  payload: { identification_code, mustShowSnackbar },
})

export const setIsVendorInMyNetwork = (id, isInMyNetwork) => ({
  type: actionTypes.FAKE_ADD_VENDOR,
  payload: { id, isInMyNetwork },
})

export const exportToCSV = ({ id, keyword, filters, data, translator }) => ({
  type: actionTypes.EXPORT,
  payload: { id, keyword, filters, data, translator },
})
